import { mobileSocket } from "../lib/socket";
import {
  userRecord,
  serviceUpload,
  serviceAdv,
  userStatistics,
} from "../api/system/sys_plateform";
import {
  sendMessageMobile,
  adminAppCustomer,
} from "../api/system/sys_plateform";
import { setLoc, getLoc, getGuid } from "../lib/utils";

// 移除 import { mapState } from 'vuex';

var mp3 = require("@/assets/notice.wav");

export const socketServer = {
  data() {
    return {
      // 手动维护 isMobile 状态
      isMobile: false,
      userAgentType: 0,
      mp3: new Audio(mp3),
      inputConType: 1,
      userMessage: "",
      chatServerData: {
        avatar: "",
        nickname: "",
        site_name: "",
        user_id: "",
        to_user_avatar: "",
        to_user_id: "",
        to_user_nickname: "",
        uid: "",
        serviceList: [], // 聊天记录
      },
      chatStatus: false,
      toChat: false,
      upperStrataData: {},
      upperData: {}, // 外部链接携带进来的参数
      unreadMessages: "",
      userKey: "",
      productMessage: {},
      isShowProductModel: false, // 是否显示携带商品
      copyFile: "", // 粘贴在输入框中的file文件
      unReadMesage: 0, // 未读消息数
      advertisement: "", // 广告
      bus: {}, // WebSocket 实例容器
    };
  },
  // 移除 computed 中的 mapState
  computed: {
    // 如果需要其他计算属性可以保留在这里
  },
  directives: {
    paste: {
      bind(el, binding, vnode) {
        el.addEventListener("paste", function (event) {
          binding.value(event);
        });
      },
    },
  },
  async created() {
    // 1. 初始化设备检测并添加监听
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    this.redirect();
    this.loadJS();

    // 获取url参数
    this.upperData = this.$route.query;
    // 更新token
    let tokenName = this.$route.query.tokenName || "token";
    let token = this.$route.query[tokenName];

    try {
      let res = await adminAppCustomer();
      if (res && res.status == 200 && res.data && res.data.list && res.data.list.length) {
        token = res.data.list[0].token_md5;
      }
    } catch (e) {
      console.error("获取客户Token失败", e);
    }

    if (token && token != getLoc("mobile_token")) {
      setLoc("mobile_token", token);
    }

    // 将url参数存入缓存
    Object.keys(this.upperData).forEach((item) => {
      if (this.upperData[item]) {
        setLoc(item, this.upperData[item]);
      }
    });

    this.getUserRecord();

    // 消息监听
    window.addEventListener("message", this.handleWindowMessage);

    this.getServiceAdv();
    this.userStatistics();
  },

  // 记得销毁监听器防止内存泄漏
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("message", this.handleWindowMessage);
  },

  watch: {
    productMessage: {
      handler(val, oldVal) {
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.isShowProductModel = true;
          this.goPageBottom();
        }
      },
      deep: true,
    },
    // 监听 isMobile 变化进行重定向
    isMobile(n) {
      this.redirect();
    },
  },

  methods: {
    // 手动检测是否为移动端的方法
    handleResize() {
      const width = window.innerWidth;
      // 通常 768px 以下认为是移动端，或者你可以增加对 UA 的判断
      this.isMobile =
        width <= 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
    },

    // 安全获取 WebSocket 实例
    safeGetWs() {
      if (!this.bus.pageWs) {
        console.warn("WebSocket 尚未连接");
        return null;
      }
      return this.bus.pageWs;
    },

    // 抽离 window message 处理逻辑以便销毁
    handleWindowMessage(e) {
      switch (e.data.type) {
        case "getImgOrText":
          this.userKey = e.data.key;
          if (e.data.productInfo) {
            this.productMessage = e.data.productInfo;
          }
          break;
        case "openCustomeServer": {
          const promise = this.safeGetWs();
          if (!promise) return;
          promise.then((ws) => {
            ws.send({
              type: "to_chat",
              data: { id: this.chatServerData.to_user_id },
            });
            this.toChat = true;
            if (this.unReadMesage) {
              this.getUserRecord();
            }
          });
          break;
        }
        case "closeCustomeServer": {
          const promise = this.safeGetWs();
          if (!promise) return;
          promise.then((ws) => {
            ws.send({ type: "to_chat", data: { id: 0 } });
            this.toChat = true;
          });
          break;
        }
        case "chat":
          if (e.data.data && e.data.data.type) {
            const promise = this.safeGetWs();
            if (!promise) return;
            promise.then((ws) => {
              ws.send({ type: e.data.data.type, data: e.data.data.data });
            });
          }
          break;
      }
    },

    loadJS() {
      var userAgent = navigator.userAgent;
      const scriptLoader = (src) => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        document.head.appendChild(script);
      };

      if (userAgent.indexOf("AlipayClient") > -1) {
        this.userAgentType = 1;
        scriptLoader("https://appx/web-view.min.js");
      } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
        this.userAgentType = 2;
        scriptLoader(
          "https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js"
        );
      } else if (
        /miniProgram/i.test(userAgent) &&
        /micromessenger/i.test(userAgent)
      ) {
        this.userAgentType = 3;
        scriptLoader("https://res.wx.qq.com/open/js/jweixin-1.4.0.js");
      } else if (/toutiaomicroapp/i.test(userAgent)) {
        this.userAgentType = 4;
        scriptLoader("https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js");
      } else if (/swan/i.test(userAgent)) {
        this.userAgentType = 5;
        scriptLoader(
          "https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js"
        );
      } else if (/quickapp/i.test(userAgent)) {
        this.userAgentType = 6;
        scriptLoader("https://quickapp/jssdk.webview.min.js");
      }

      // 加载 IP 检测脚本
      const ipScript = document.createElement("script");
      ipScript.src = "https://pv.sohu.com/cityjson?ie=utf-8";
      document.head.appendChild(ipScript);
    },

    userStatistics() {
      let ua = window.navigator.userAgent;
      let browser = "Unknown";
      if (ua.indexOf("MSIE") != -1 || "ActiveXObject" in window) browser = "IE";
      else if (ua.indexOf("Firefox") != -1) browser = "Firefox";
      else if (ua.indexOf("Chrome") != -1) browser = "Chrome";
      else if (ua.indexOf("Opera") != -1) browser = "Opera";
      else if (ua.indexOf("Safari") != -1) browser = "Safari";

      userStatistics({
        ip: window.returnCitySN ? window.returnCitySN.cip : "",
        path: window.location.url + '/chat/pc?token=' + getLoc("mobile_token"),
        source: window.parent.location.url + '/chat/pc?token=' + getLoc("mobile_token"),
        browser: browser,
      });
    },

    redirect() {
      const deviceType = this.$route.query.deviceType || "pc";
      // 使用 replace 避免在浏览器历史中留下多余的记录，确保用户点一次返回就能回到上一页
      if (this.isMobile && deviceType == "pc" && this.$route.name !== "customerServerPc") {
        this.$router
          .replace({ name: "customerServerMobile", query: this.$route.query })
          .catch(() => {});
      } else if (!this.isMobile && deviceType == "mobile" && this.$route.name !== "customerServerMobile") {
        this.$router
          .replace({ name: "customerServerPc", query: this.$route.query })
          .catch(() => {});
      }
    },

    getServiceAdv() {
      serviceAdv().then((res) => {
        if (res.status == 200) this.advertisement = res.data.content;
      });
    },

    getUserRecord() {
      let postData = {
        uid: this.upperData.uid || getLoc("uid") || 0,
        limit: 20,
        nickname: this.upperData.nickName,
        phone: this.upperData.phone,
        sex: this.upperData.sex,
        avatar: this.upperData.avatar,
        openid: this.upperData.openid,
        kefu_id: this.upperData.kefu_id || 0,
        toUserId: getLoc("to_user_id") || 0,
        type: this.isMobile ? "3" : "0", // 直接使用本地 isMobile
      };

      userRecord(postData)
        .then((res) => {
          this.chatServerData = res.data;
          this.unReadMesage = 0;
          this.goPageBottom();

          // /user/record 返回的 uid 是服务端分配的权威标识。
          // chatOptinos 发送消息时使用 chatServerData.user_id，服务器期望 i32；
          // res.data.uid 可能是字符串（如 Snowflake ID），转成 Number 避免反序列化失败
          if (res.data.uid) {
            this.chatServerData.user_id = Number(res.data.uid);
          }

          let cookieData = [
            "nickname",
            "uid",
            "user_id",
            "avatar",
            "to_user_id",
            "to_user_nickname",
          ];
          cookieData.forEach((item) => {
            // 服务端返回的数据是权威源，优先使用；本地缓存作为兜底
            setLoc(item, res.data[item] || getLoc(item));
          });

          if (res.data.welcome) this.pushMessageToList(res.data.welcome);

          document.title = res.data.to_user_nickname
            ? `正在和${res.data.to_user_nickname}对话中 - ${this.chatServerData.site_name}`
            : "对话中 - " + this.chatServerData.site_name;

          this.connnectServer();
        })
        .catch((rej) => {
          if (rej.status == 400) {
            this.$router.replace({
              name: "customerOutLine",
              query: this.$route.query,
            });
          }
        });
    },

    connnectServer() {
      let token = getLoc("mobile_token");
      let formTerminal = this.isMobile ? "h5" : "pc";

      // 注意：确保这里调用的是 import 进来的 mobileSocket
      this.bus.pageWs = mobileSocket(true, token, formTerminal);
      this.bus.pageWs.then((ws) => {
        ws.$on("close", () => {
          this.toChat = false;
          this.chatStatus = false;
        });

        ws.$on("kefu_logout", (data) => {
          if (data.online == 0) {
            this.$router.replace({
              name: "customerOutLine",
              query: this.$route.query,
            });
          }
        });

        ws.$on(["reply", "chat"], (data) => {
          this.chatServerData.serviceList.push(data);
          this.goPageBottom();
        });

        ws.$on("reply", (data) => {
          try {
            this.mp3.play();
          } catch (e) {}
          parent.postMessage({ type: "onMessageChat", data: data }, "*");
        });

        ws.$on("user", (data) => {
          this.chatServerData.nickname = data.nickname;
          this.chatServerData.user_id = data.uid;
          setLoc("uid", data.uid);
        });

        ws.$on("success", (data) => {
          this.chatStatus = true;
          let to_user_id =
            !this.upperData.isShowTip || this.upperData.isShowTip == "undefined"
              ? this.chatServerData.to_user_id
              : 0;

          let uid = Number(this.chatServerData.uid || this.upperData.userId || 10001);

          // 向服务器注册用户信息前，先本地持久化 uid，
          // 防止服务器不回传 "user" 事件导致 setLoc 遗漏
          setLoc("uid", uid);
          setLoc("user_id", uid);
          // chatOptinos 发送消息使用 user_id，与 uid 保持同步
          this.chatServerData.user_id = uid;

          ws.send({
            type: "user",
            data: {
              to_user_id: to_user_id,
              uid: uid,
              nickname: this.chatServerData.nickname,
              avatar: this.chatServerData.avatar,
              phone: this.userMessage.phone || this.chatServerData.phone,
              openid: this.upperData.openid,
              type: this.isMobile ? "3" : "0",
            },
          });

          if (!to_user_id && !this.toChat && this.chatServerData.to_user_id) {
            ws.send({
              data: { id: this.chatServerData.to_user_id, test: 1 },
              type: "to_chat",
            });
            this.toChat = true;
          }
          parent.postMessage({ type: "onMessageSuccess", data: {} }, "*");
        });

        ws.$on("mssage_num", (data) => {
          if (data.num > 0) {
            this.mp3.play();
            this.unReadMesage = data.num;
          }
          parent.postMessage(
            { type: "onMessageNum", data: { num: data.num } },
            "*"
          );
        });

        ws.$on("to_transfer", (data) => {
          this.chatServerData.to_user_id = data.toUid;
          this.chatServerData.to_user_nickname = data.nickname;
          this.chatServerData.to_user_avatar = data.avatar;
          ws.send({ type: "to_chat", data: { id: data.toUid } });
          this.toChat = true;
          document.title = `正在和${data.nickname}对话中`;
          parent.postMessage({ type: "onMessageTransfer", data: data }, "*");
        });
      })
      .catch((err) => {
        console.error("WebSocket 连接失败:", err);
        this.chatStatus = false;
      });
    },

    goPageBottom() {
      this.$nextTick(() => {
        const el = document.querySelector("#chat_scroll");
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },

    sendProduct() {
      const promise = this.safeGetWs();
      if (!promise) return;
      promise.then((ws) => {
        ws.send({
          type: "chat",
          data: {
            to_user_id: this.chatServerData.to_user_id,
            uid: this.chatServerData.uid,
            type: 5,
            other: this.productMessage,
          },
        });
        parent.postMessage(
          { type: "sendImageText", data: this.productMessage },
          "*"
        );
      });
      this.isShowProductModel = false;
      this.goPageBottom();
    },

    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        this.update(file);
      } else {
        this.$message.warning("只能上传单张图片且无法复制本地文件");
      }
    },

    update(file) {
      let param = new FormData();
      param.append("filename", "file");
      param.append("file", file);
      serviceUpload(param).then((res) => {
        if (res.status == 200) {
          this.sendMsg(res.data.url, 3);
          parent.postMessage(
            { type: "sendImage", data: { url: res.data.url } },
            "*"
          );
          if (this.$refs["inputDiv"]) this.$refs["inputDiv"].innerText = "";
        }
      });
    },

    select(item) {
      if (this.isMobile || !this.$refs["inputDiv"]) {
        this.userMessage += `[${item}]`;
      } else {
        this.inputConType = 1;
        this.$refs["inputDiv"].innerText += `[${item}]`;
      }
    },

    sendText() {
      let sendMessage = this.$refs["inputDiv"]
        ? this.$refs["inputDiv"].innerText.replace(/[\r\n]/g, "")
        : this.userMessage.replace(/[\r\n]/g, "");

      if (sendMessage) {
        this.sendMsg(sendMessage, 1);
        if (this.$refs["inputDiv"]) this.$refs["inputDiv"].innerText = "";
        this.userMessage = "";
      } else {
        this.$Message.error("请先输入信息");
      }
    },

    sendMsg(msn, type) {
      if (!this.chatStatus) return this.$Message.error("正在连接中");
      let guid = getGuid();
      let chat = this.chatOptinos(guid, msn, type);
      sendMessageMobile(chat).then((res) => {
        chat.add_time = Date.parse(new Date()) / 1000;
        this.pushMessageToList(chat);
        if (res.data.autoReply) this.pushMessageToList(res.data.autoReplyData);
        this.goPageBottom();
      });
    },

    pushMessageToList(data) {
      this.chatServerData.serviceList.push(data);
    },

    chatOptinos(guid, msn, type, other) {
      return {
        msn,
        msn_type: type,
        to_user_id: Number(this.chatServerData.to_user_id),
        is_send: 0,
        is_tourist: 0,
        avatar: this.chatServerData.avatar,
        user_id: Number(this.chatServerData.user_id),
        appid: this.chatServerData.appid,
        other: other || {},
        type: 0,
        guid: guid,
      };
    },

    scrollHandler(e) {
      this.isLoad = true;
      userRecord({
        limit: 20,
        uid: this.chatServerData.uid,
        idTo: this.chatServerData.serviceList[0]?.id || "",
        toUserId: this.chatServerData.to_user_id,
      }).then((res) => {
        if (res.status == 200) {
          res.data.serviceList.reverse().forEach((item) => {
            this.chatServerData.serviceList.unshift(item);
          });
        }
        this.isLoad = false;
      });
    },

    closeIframe() {
      parent.postMessage({ type: "closeWindow" }, "*");
      const promise = this.safeGetWs();
      if (!promise) return;
      promise.then((ws) => {
        ws.send({ type: "to_chat", data: { id: 0 } });
        this.toChat = true;
      });
    },

    textareaInput() {
      this.inputConType = 1;
    },
    selectEmoji() {
      this.inputConType = 2;
      this.goPageBottom();
    },

    // 图片处理相关保持不变...
    dataURLtoFile(dataurl, f) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], f.name, { type: mime });
    },
    compressImg(file) {
      return new Promise((resolve) => {
        let read = new FileReader();
        read.readAsDataURL(file);
        read.onload = (e) => {
          let img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            let fileSize = file.size / 1024 / 1024;
            let quality = fileSize < 1 ? 1 : fileSize < 2 ? 0.5 : 0.2;
            let base64 = canvas.toDataURL(file.type, quality);
            resolve(this.dataURLtoFile(base64, file));
          };
        };
      });
    },
    uploadFile(e) {
      if (!e.target.files[0]) return;
      this.compressImg(e.target.files[0]).then((file) => {
        let formData = new FormData();
        formData.append("filename", "file");
        formData.append("file", file);
        serviceUpload(formData)
          .then((res) => {
            if (res.status == 200) this.sendMsg(res.data.url, 3);
          })
          .catch((rej) => this.$Message.error(rej.msg));
      });
    },
  },
};
